import React, { Component } from "react";

export default class StatField extends Component {
  /*constructor(props) {
    super(props);
  }*/

  componentDidMount() {}

  render() {
    let otherStyle = {
      color: "white",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      height: "100 %"
    };
    let style = {
      ...otherStyle,
      ...{ display: "flex" }
    };
    if (this.props.marked) {
      style.backgroundColor = "#0005";
    }
    return (
      <div style={style}>
        <div style={otherStyle}>
          <p style={{ fontSize: "4em" }}>{this.props.children}</p>
          <p>{this.props.title}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/StatField.js